import React from "react";

export default ({ width = 35, height = 35, className }) => (
  <svg
    className={className}
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 435 445"
  >
    <g>
      <path
        d="M82.255,191.38 L22.546,130.798 L46.776,120.414 L105.62,168.008 L208.597,66.762 L268.306,95.319 L268.306,287.428 L208.597,315.119 L106.485,216.469 L45.045,262.333 L22.546,250.218 L82.255,191.38 Z M207.731,241.563 L207.731,140.317 L145.426,190.94 L207.731,241.563 Z"
        id="Shape"
      />
      <polygon
        id="Shape"
        points="0.046 331.56 322.823 380.885 322.823 0.995 434.454 52.051 434.454 398.193 324.554 444.922"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/common/tools/VSCode.js